import { ModelEntityType } from '@upright/common/model/input/types';
import {
  SdgAlignmentLevel,
  SdgAlignmentsBySdgAndLevel,
  SdgAlignmentValence,
  SdgId,
  SdgTarget,
} from '@upright/common/model/output/scores/sdg-alignment/types';

interface DrillDownParams {
  sdgId: SdgId;
  valence: SdgAlignmentValence;
}
export interface GetCompanySdgAlignmentsRequestParams {
  entityType: ModelEntityType.COMPANY;
  entityId: string;
  release: string;
  resultOrVariantId: string;
}
export interface GetWeightSetSdgAlignmentsRequestParams {
  entityType: ModelEntityType.GROUP | ModelEntityType.PORTFOLIO;
  entityId: string;
  release: string;
  resultOrVariantId: number;
}

export interface GetProductSdgAlignmentsRequestParams {
  entityType: ModelEntityType.PRODUCT;
  productCode: string;
  version: string;
}

export type GetSdgAlignmentsRequestParams =
  | GetCompanySdgAlignmentsRequestParams
  | GetWeightSetSdgAlignmentsRequestParams;

export type GetCompanySdgDrilldownRequestParams = GetCompanySdgAlignmentsRequestParams & DrillDownParams;
export type GetWeightSetSdgDrilldownRequestParams = GetWeightSetSdgAlignmentsRequestParams & DrillDownParams;

export type GetSdgDrilldownRequestParams = GetCompanySdgDrilldownRequestParams | GetWeightSetSdgDrilldownRequestParams;

export type SdgDrillability =
  | { drillable: true; reason: undefined }
  | { drillable: false; reason: NoDrillabilityReason };

export enum NoDrillabilityReason {
  SDG8 = 'SDG8',
  SINGLE_ALIGNED_PRODUCT = 'SINGLE_ALIGNED_PRODUCT', // Note: These also apply to groups and portfolios, i.e. single aligned constituent // TODO rename
  SINGLE_STRONG_ALIGNED_PRODUCT = 'SINGLE_STRONG_ALIGNED_PRODUCT',
  SINGLE_MODERATELY_ALIGNED_PRODUCT = 'SINGLE_MODERATELY_ALIGNED_PRODUCT',
  COVERAGE_CLASS_EXTENDED = 'COVERAGE_CLASS_EXTENDED',
  NO_DATA = 'NO_DATA',
}

export interface SdgDrillDownTableRow {
  type: ModelEntityType;
  id: string;
  name: string;
  targets: TargetAndLevel[];
  strongestLevel: SdgAlignmentLevel;
  alignment: number | undefined;
}

interface TargetAndLevel {
  target: SdgTarget | undefined;
  level: SdgAlignmentLevel;
}

export type GetSdgAlignmentsResponse = SdgAlignmentsBySdgAndLevel;
export type GetSdgAlignmentsDrilldownResponse = { drillability: SdgDrillability; rows: SdgDrillDownTableRow[] };
